// utils/helpers/helper.constant.js
import React from 'react';
import { i18n } from "engine/Contexts/AppProviders";

import _local from "utils/localStorageUtils";

export const COURSE_TIME_RANGE = 5;

export const SUBJECTS_BY_SCHOOL = [
  {
    label: "Activité en classe",
    color: "#5C2A9D",
  },
  {
    label: "Activité extra-scolaire",
    color: "#49BEB7",
  },
  {
    label: "Math",
    color: "#000000",
  },
  {
    label: "Sciences",
    color: "#000000",
  },
  {
    label: "Français",
    color: "#2070FF",
  },
  {
    label: "Allemand",
    color: "#B620E0",
  },
  {
    label: "Anglais",
    color: "#FF004E",
  },
  {
    label: "Sport",
    color: "#B200CA",
  },
  {
    label: "Informatique",
    color: "#612712",
  },
  {
    label: "Histoire",
    color: "#0200FF",
  },
  {
    label: "Religion",
    color: "#C5CA00",
  },
  {
    label: "Géographie",
    color: "#47D326",
  },
  {
    label: "Art visuel",
    color: "#CA0000",
  },
  {
    label: "Musique",
    color: "#CA6400",
  },
];
// INFO: for the moment, we don't use it in the project, but we can use it as example
export const SUBJECTS_OPTIONS = SUBJECTS_BY_SCHOOL?.map(elem => {
  return {
    key: elem.label,
    label: elem.label,
    value: elem.label,
    color: elem.color,
  };
}).sort((a, b) => a?.label?.localeCompare(b?.label));

// Motif: Medical
export const DISPENSARY_PROGRAM = [
  {
    key: "Médecin généraliste",
    value: "Médecin généraliste",
    label: "absences.programs.general_practitioner"
  },
  {
    key: "Dentiste",
    value: "Dentiste",
    label: "absences.programs.dentist"
  },
  {
    key: "Orthophoniste",
    value: "Orthophoniste",
    label: "absences.programs.speech_therapist"
  },
  {
    key: "Psychiatre",
    value: "Psychiatre",
    label: "absences.programs.psychiatrist"
  },
  {
    key: "Neurologue",
    value: "Neurologue",
    label: "absences.programs.neurologist"
  },
  {
    key: "Endocrinologue",
    value: "Endocrinologue",
    label: "absences.programs.endocrinologist"
  },
  {
    key: "Chirurgien",
    value: "Chirurgien",
    label: "absences.programs.surgeon"
  },
  {
    key: "Urologue-andrologue",
    value: "Urologue-andrologue",
    label: "absences.programs.urologist_andrologist"
  },
  {
    key: "Traumatologue-orthopédiste",
    value: "Traumatologue-orthopédiste",
    label: "absences.programs.traumatologist_orthopedist"
  },
];
export const DISPENSARY_PROGRAM_OPTIONS = () => {
  return DISPENSARY_PROGRAM?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      value: elem?.value,
    };
  }).sort((a, b) => a?.label?.localeCompare(b?.label))
};

// No-Medical
export const ACTIVITY_REASON = [
  {
    key: "Sport, Art et Formation",
    value: "Sport, Art et Formation",
    label: "absences.activityReason.sport_art_training"
  },
  {
    key: "Stage",
    value: "Stage",
    label: "absences.activityReason.internship"
  },
  {
    key: "Congé",
    value: "Congé",
    label: "absences.activityReason.leave"
  },
  {
    key: "Jour joker",
    value: "Jour joker",
    label: "absences.activityReason.joker_day"
  },
  {
    key: "Autre",
    value: "Autre",
    label: "absences.activityReason.other"
  },
];
export const ACTIVITY_REASON_OPTIONS = () => {
  return ACTIVITY_REASON?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  }).sort((a, b) => a?.label?.localeCompare(b?.label))
};

// only for parent and for communication creation functionality
export const PARENT_COMM_REASON = [
  {
    key: "Demande d’information",
    value: "Demande d’information",
    label: "news.parentCommReason.information",
  },
  {
    key: "Rendez-vous",
    value: "Rendez-vous",
    label: "news.parentCommReason.appointments",
  },
  {
    key: "Divers",
    value: "Divers",
    label: "news.parentCommReason.different",
  },
];
export const PARENT_COMM_REASON_OPTIONS = () => {
  return PARENT_COMM_REASON?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      value: elem?.value,
    };
  }).sort((a, b) => a?.label?.localeCompare(b?.label))
};

// Récurrence
export const RECURRING = [
  {
    key: "every_week",
    value: "every_week",
    label: "absences.recurringReason.every_week",
  },
  {
    key: "every_month",
    value: "every_month",
    label: "absences.recurringReason.every_month",
  },
];
export const RECURRING_OPTIONS = () => {
  return RECURRING?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      value: elem?.value,
    };
  }).sort((a, b) => a?.label?.localeCompare(b?.label))
};

// 1 - Monday
// 7 - Sunday
export const DAY_OF_WEEK = [
  {
    key: "monday", // Lun, Lu
    label: "global.dayOfWeek.monday.label",
    value: "lundi",
  },
  {
    key: "tuesday", // Mar, Ma
    label: "global.dayOfWeek.tuesday.label",
    value: "mardi",
  },
  {
    key: "wednesday", // Mer, Me
    label: "global.dayOfWeek.wednesday.label",
    value: "mercredi",
  },
  {
    key: "thursday", // Jeu, Je
    label: "global.dayOfWeek.thursday.label",
    value: "jeudi",
  },
  {
    key: "friday", // Ven, Ve
    label: "global.dayOfWeek.friday.label",
    value: "vendredi",
  },
  {
    key: "saturday", // Sam, Sa
    label: "global.dayOfWeek.saturday.label",
    value: "samedi",
  },
  {
    key: "sunday", // Dim, Di
    label: "global.dayOfWeek.sunday.label",
    value: "dimanche",
  },
];
export const DAY_OF_WEEK_OPTIONS = () => {
  return DAY_OF_WEEK?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  });
};

export const STATUSES_LIST = [
  {
    key: "pending",
    label: "global.statuses.pending",
    value: "pending",
  },
  {
    key: "justification-missing",
    label: "global.statuses.justification-missing",
    value: "justification-missing",
  },
  {
    key: "sick",
    label: "global.statuses.sick",
    value: "sick",
  },
  {
    key: "sickness-finish",
    label: "global.statuses.sickness-finish",
    value: "sickness-finish",
  },
  {
    key: "accepted",
    label: "global.statuses.accepted",
    value: "accepted",
  },
  {
    key: "refused",
    label: "global.statuses.refused",
    value: "refused",
  },
  {
    key: "unjustified",
    label: "global.statuses.unjustified",
    value: "unjustified",
  },
];
export const STATUSES_LIST_OPTIONS = () => {
  return STATUSES_LIST?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  });
};

export const ABS_TYPES_LIST = [
  {
    key: "sickness",
    value: "sickness",
    label: "global.absenceTypes.sickness",
    title: "global.absenceTypes.sickness",
  },
  {
    key: "medical",
    value: "medical",
    label: "global.absenceTypes.medical",
    title: "global.absenceTypes.medical",
  },
  {
    key: "no-medical",
    value: "no-medical",
    label: "global.absenceTypes.no-medical",
    title: "global.absenceTypes.no-medical",
  },
  {
    key: "unjustified",
    value: "unjustified",
    label: "global.absenceTypes.unjustified",
    title: "global.absenceTypes.unjustified",
  }
];
export const ABS_TYPES_LIST_OPTIONS = () => {
  return ABS_TYPES_LIST?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  });
};


export const ABS_TYPES_LIST_WITH_LABEL = [
  {
    key: "sickness",
    value: "sickness",
    label: "global.absenceTypesFull.sickness",
    title: "global.absenceTypesFull.sickness",
  },
  {
    key: "medical",
    value: "medical",
    label: "global.absenceTypesFull.medical",
    title: "global.absenceTypesFull.medical",
  },
  {
    key: "no-medical",
    value: "no-medical",
    label: "global.absenceTypesFull.no-medical",
    title: "global.absenceTypesFull.no-medical",
  },
  {
    key: "unjustified",
    value: "unjustified",
    label: "global.absenceTypesFull.unjustified",
    title: "global.absenceTypesFull.unjustified",
  }
];
export const ABS_TYPES_LIST_WITH_LABEL_OPTIONS = () => {
  return ABS_TYPES_LIST_WITH_LABEL?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  });
};

export const TYPES_LIST = [
  {
    key: "documents",
    value: "documents",
    label: "global.formTypes.documents",
    title: "global.formTypes.documents",
  },
  {
    key: "forms",
    value: "forms",
    label: "global.formTypes.forms",
    title: "global.formTypes.forms",
  },
  {
    key: "appointments",
    value: "appointments",
    label: "global.formTypes.appointments",
    title: "global.formTypes.appointments",
  },
  {
    key: "discussion",
    value: "discussion",
    label: "global.formTypes.discussion",
    title: "global.formTypes.discussion",
  },
  {
    key: "no-type",
    value: "no-type",
    label: "global.formTypes.no-type",
    title: "global.formTypes.no-type",
  },
];
export const TYPES_LIST_OPTIONS = () => {
  return TYPES_LIST?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  });
};

export const LEVELS = [
  {
    key: 0,
    label: "inputs.noLevel",
    value: 0,
  },
  {
    key: 1,
    label: "inputs.levels.level_1",
    value: 1,
  },
  {
    key: 2,
    label: "inputs.levels.level_2",
    value: 2,
  },
  {
    key: 3,
    label: "inputs.levels.level_3",
    value: 3,
  },
  // {
  //   key: 4,
  //   label: "inputs.levels.level_4",
  //   value: 4,
  // },
  // {
  //   key: 5,
  //   label: "inputs.levels.level_5",
  //   value: 5,
  // },
];
export const LEVELS_OPTIONS = () => {
  return LEVELS?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  });
};

export const PERIODS = [
  {
    key: 0,
    label: "inputs.noRule",
    value: 0,
  },
  {
    key: 1,
    label: "inputs.periods.period_1",
    value: 1,
  },
  {
    key: 2,
    label: "inputs.periods.period_2",
    value: 2,
  },
  {
    key: 3,
    label: "inputs.periods.period_3",
    value: 3,
  },
  {
    key: 4,
    label: "inputs.periods.period_4",
    value: 4,
  },
  {
    key: 5,
    label: "inputs.periods.period_5",
    value: 5,
  },
  {
    key: 6,
    label: "inputs.periods.period_6",
    value: 6,
  },
  {
    key: 7,
    label: "inputs.periods.period_7",
    value: 7,
  },
  {
    key: 8,
    label: "inputs.periods.period_8",
    value: 8,
  },
];

export const PERIOD_OPTIONS = () => {
  return PERIODS?.map(elem => {
    return {
      key: elem?.key,
      label: i18n.t(elem?.label),
      title: i18n.t(elem?.label),
      value: elem?.value,
    };
  });
};

export const YEARS_OPTIONS = [
  {
    key: "2023 - 2024",
    label: "2023 - 2024",
    value: "2023 - 2024",
  },
  {
    key: "2024 - 2025",
    label: "2024 - 2025",
    value: "2024 - 2025",
  },
];

export const ABSENCES_DURATIONS = {
  all: {
    month: "140 heures 45 minutes",
    semester: "2400 heures 30 minutes",
    year: "6003 heures",
  },
  medical: {
    month: "31 heures 15 minutes",
    semester: "411 heures",
    year: "1056 heures 15 minutes",
  },
  nonMedical: {
    month: "23 heures 30 minutes",
    semester: "200 heures",
    year: "560 heures 30 minutes",
  },
  sickness: {
    month: "86 heures",
    semester: "1789 heures 30 minutes",
    year: "4386 heures 15 mintutes",
  },
};

export const ABSENCES_DURATIONS_STUDENT = {
  all: {
    month: "14 heures",
    semester: "40 heures 30 minutes",
    year: "64 heures 45 minutes",
  },
  medical: {
    month: "5 heures 30 minutes",
    semester: "3 heures 5 minutes",
    year: "28 heures",
  },
  nonMedical: {
    month: "1 heures 30 minutes",
    semester: "16 heures 55 minutes",
    year: "8 heures",
  },
  sickness: {
    month: "7 heures",
    semester: "20 heures 30 minutes",
    year: "28 heures 45 minutes",
  },
};

export const USER_TYPES = {
  student: "labels.student",
  teacher: "labels.teacher",
  parent: "labels.parent",
  admin: "labels.admin",
};
export const USER_TYPES_OPTIONS = (role) => {
  return i18n.t(USER_TYPES[role?.toLocaleLowerCase()]);
};

export const AUDIENCE_TABLE_STATUS = {
  read: "audiences.statuses.read",
  notRead: "audiences.statuses.notRead",
  answered: "audiences.statuses.answered",
};

export const AUDIENCE_TABLE_STATUS_OPTIONS = (status) => {
  return i18n.t(AUDIENCE_TABLE_STATUS[status]);
};
